import { render, staticRenderFns } from "./Complaint.vue?vue&type=template&id=07cd9a02&scoped=true"
import script from "./Complaint.vue?vue&type=script&lang=js"
export * from "./Complaint.vue?vue&type=script&lang=js"
import style0 from "./Complaint.vue?vue&type=style&index=0&id=07cd9a02&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../../../../Users/lyb/工作/个人/leo——im/新版代码/box-im/im-web/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07cd9a02",
  null
  
)

export default component.exports